import axios from "axios";
import designsData from '../data/designs.json';

const API_URL = process.env.REACT_APP_API_URL;
const YOUTUBE_API_KEY = process.env.REACT_APP_GOOGLE_CLOUD_API_KEY;
const STATIC_WEBSITE = process.env.REACT_APP_STATIC_WEBSITE === 'True';

const DesignService = {
    getAllDesigns: async () => {
        try {
            if (STATIC_WEBSITE) {
                return designsData;
            } else {
                const response = await axios.get(`${API_URL}/designs/`);
                return response.data;
            }
        } catch (error) {
            console.error("Error fetching designs:", error);
            throw error;
        }
    },

    getRedditData: async (redditLink) => {
        if (!redditLink) return null;
        
        try {
            const redditJsonUrl = `${redditLink.replace(/\/$/, "")}.json`;
            const redditResponse = await axios.get(redditJsonUrl, { timeout: 3000 });
            const redditData = redditResponse.data?.[0]?.data?.children?.[0]?.data;
            return {
                reddit_score: redditData?.score ?? null,
                reddit_comments: redditData?.num_comments ?? null,
            };
        } catch {
            return { reddit_score: null, reddit_comments: null };
        }
    },

    extractYouTubeVideoId: (url) => {
        if (!url) return null;
        
        // Handle various YouTube URL formats including Shorts
        const patterns = [
            /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/,
            /youtube\.com\/embed\/([^&\n?#]+)/,
            /youtube\.com\/v\/([^&\n?#]+)/,
            /youtube\.com\/shorts\/([^&\n?#]+)/,
        ];

        for (const pattern of patterns) {
            const match = url.match(pattern);
            if (match && match[1]) {
                return match[1];
            }
        }
        return null;
    },

    getYouTubeData: async (youtubeLink) => {
        if (!youtubeLink || !YOUTUBE_API_KEY) return null;
        
        const videoId = DesignService.extractYouTubeVideoId(youtubeLink);
        if (!videoId) return { youtube_views: null, youtube_likes: null };

        try {
            const response = await axios.get(
                `https://www.googleapis.com/youtube/v3/videos`,
                {
                    params: {
                        part: 'statistics',
                        id: videoId,
                        key: YOUTUBE_API_KEY,
                    },
                    timeout: 5000,
                }
            );

            const stats = response.data?.items?.[0]?.statistics;
            return {
                youtube_views: stats?.viewCount ? parseInt(stats.viewCount) : null,
                youtube_likes: stats?.likeCount ? parseInt(stats.likeCount) : null,
            };
        } catch (error) {
            console.error("Error fetching YouTube data:", error);
            return { youtube_views: null, youtube_likes: null };
        }
    },
};

export default DesignService;